import { render } from "./gdpr-settings.vue?vue&type=template&id=18b5262e"
import script from "./gdpr-settings.vue?vue&type=script&lang=js"
export * from "./gdpr-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__